import { makeAuthenticatedRequest } from './api';


export const getCategoryById = async (id) => {
    try {
        return await makeAuthenticatedRequest(`/categories/${id}`, 'GET')
            .then(response => {
                // Check if the request was successful (status code 200-299)
                if (!response.ok) {
                    return { ok: false, error: response };
                }
                // Parse the response as JSON
                return response.json();
            })
            .then(data => {
                // Handle the JSON data
                return { ok: true, data: data };
            })
            .catch(error => {
                // Handle errors
                console.error('Fetch error:', error);
                return { ok: false, error: error };
            });

    } catch (error) {
        // Handle network errors or unexpected issues
        console.error('Error during login:', error);
        return { ok: false, error: error };
    }
}

export const getAllCategories = async () => {
    try {
        return await makeAuthenticatedRequest('/categories', 'GET')
            .then(response => {
                // Check if the request was successful (status code 200-299)
                if (!response.ok) {
                    return { ok: false, error: response };
                }
                // Parse the response as JSON
                return response.json();
            })
            .then(data => {
                // Handle the JSON data
                return { ok: true, data: data };
            })
            .catch(error => {
                // Handle errors
                console.error('Fetch error:', error);
                return { ok: false, error: error };
            });

    } catch (error) {
        // Handle network errors or unexpected issues
        console.error('Error during login:', error);
        return { ok: false, error: error };
    }
}

export const searchCategory = async (searchTerm) => {
    try {
        const endpoint = `/categories/?search=${encodeURIComponent(searchTerm)}`;
        return await makeAuthenticatedRequest(endpoint, 'GET')
            .then(response => {
                // Check if the request was successful (status code 200-299)
                if (!response.ok) {
                    return { ok: false, error: response };
                }
                // Parse the response as JSON
                return response.json();
            })
            .then(data => {
                // Handle the JSON data
                return { ok: true, data: data };
            })
            .catch(error => {
                // Handle errors
                console.error('Fetch error:', error);
                return { ok: false, error: error };
            });

    } catch (error) {
        // Handle network errors or unexpected issues
        console.error('Error during searchCategory:', error);
        return { ok: false, error: error };
    }
};


export const createCategory = async (categoryData) => {
    try {

        return await makeAuthenticatedRequest("/categories", "POST", categoryData)
            .then(response => {
                // Check if the request was successful (status code 200-299)
                if (!response.ok) {
                    return { ok: false, error: response };
                }
                // Parse the response as JSON
                return response.json();
            })
            .then(data => {
                // Handle the JSON data
                return { ok: true, data: data };
            })
            .catch(error => {
                // Handle errors
                console.error('Fetch error:', error);
                return { ok: false, error: error };
            });

    } catch (error) {
        // Handle network errors or unexpected issues
        console.error('Error during createCategory:', error);
        return { ok: false, error: error };
    }
};

export const updateCategory = async (categoryId, updatedCategoryData) => {
    try {
        return await makeAuthenticatedRequest(`/categories/${categoryId}`, "PATCH", updatedCategoryData)
            .then(response => {
                // Check if the request was successful (status code 200-299)
                if (!response.ok) {
                    return { ok: false, error: response };
                }
                // Parse the response as JSON
                return response.json();
            })
            .then(data => {
                // Handle the JSON data
                return { ok: true, data: data };
            })
            .catch(error => {
                // Handle errors
                console.error('Fetch error:', error);
                return { ok: false, error: error };
            });

    } catch (error) {
        // Handle network errors or unexpected issues
        console.error('Error during updateCategory:', error);
        return { ok: false, error: error };
    }
};

export const deleteSingleCategory = async (categoryId) => {
    try {

        return await makeAuthenticatedRequest(`/categories/${categoryId}`, "DELETE")
            .then(response => {
                // Check if the request was successful (status code 200-299)
                if (!response.ok) {
                    return { ok: false, error: response };
                }
                // Parse the response as JSON
                return response.json();
            })
            .then(data => {
                // Handle the JSON data
                return { ok: true, data: data };
            })
            .catch(error => {
                // Handle errors
                console.error('Fetch error:', error);
                return { ok: false, error: error };
            });

    } catch (error) {
        // Handle network errors or unexpected issues
        console.error('Error during deleteSingleCategory:', error);
        return { ok: false, error: error };
    }
};

export const deleteMultipleCategories = async (categoryIds) => {
    try {

        return await makeAuthenticatedRequest(`/categories/${categoryIds.join(',')}`, "DELETE")
            .then(response => {
                // Check if the request was successful (status code 200-299)
                if (!response.ok) {
                    return { ok: false, error: response };
                }
                // Parse the response as JSON
                return response.json();
            })
            .then(data => {
                // Handle the JSON data
                return { ok: true, data: data };
            })
            .catch(error => {
                // Handle errors
                console.error('Fetch error:', error);
                return { ok: false, error: error };
            });

    } catch (error) {
        // Handle network errors or unexpected issues
        console.error('Error during deleteMultipleCategories:', error);
        return { ok: false, error: error };
    }
};
